import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';

import { getColors } from '~/services/MerchandiseService';

import AddColorDialog from './AddColorDialog';
import ColorsTable from './ColorsTable';

export default function Color() {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);

  const { data, isLoading, error } = useQuery({
    queryKey: ['merchandise', 'colors'],
    queryFn: async ({ signal }) => {
      const response = await getColors({ signal });
      return response.result.colors.sort((a, b) => {
        if (a.parentColor && !b.parentColor) {
          return 1;
        }
        if (b.parentColor && !a.parentColor) {
          return -1;
        }
        return a.name.localeCompare(b.name);
      });
    },
  });

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5" component="h2">
          Colour Management
        </Typography>
        <Button variant="contained" color="primary" onClick={() => setIsAddDialogOpen(true)}>
          Add new color
        </Button>
      </Box>

      <AddColorDialog open={isAddDialogOpen} onClose={() => setIsAddDialogOpen(false)} />

      {isLoading && (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Box mt={4}>
          <Alert severity="error">
            Error loading colors: {error instanceof Error ? error.message : 'Unknown error'}
          </Alert>
        </Box>
      )}

      {!isLoading && !error && <ColorsTable data={data} isLoading={isLoading} />}
    </>
  );
}
